module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ex-wrapper"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Form File")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Form File.")]), _vm._v(" "), _c('div', {
    staticClass: "example-set"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "file-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Icon Input")]), _vm._v(" "), _c('div', {
    staticClass: "name-file _bg-grey-disable"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon fa fa-paperclip",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validator-text"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25984089!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/styleGuide/ex-file.vue
// module id = 3636
// module chunks = 1